import Model from "./model";

export default new Model({
  resource: "ability",
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"name", default:"-", required: true, type:"text", width: 300},
    {label:"title", nameAttr:"title", default:"-", required: true, type:"text", width: 200},
    {label:"Rol", nameAttr:"rol", default:0, required: true, type:"text", width: 150},
  ]
});
